import { a as V, c as T, s as b, u as D } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import * as p from "react";
import { c as B, g as F } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { j as M } from "./jsx-runtime-3tyXYecC.mjs";
import { f as E, h as k, r as u, j as G, k as N, l as O, n as v } from "./tss-DN0acMKN.mjs";
import { e as U } from "./extendSxProp-BhQEuuTD.mjs";
import { u as $ } from "./useThemeProps-wW47KG21.mjs";
const A = V(), I = E(), L = A("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, s) => s.root
});
function q(e) {
  return $({
    props: e,
    name: "MuiStack",
    defaultTheme: I
  });
}
function z(e, s) {
  const n = p.Children.toArray(e).filter(Boolean);
  return n.reduce((a, c, t) => (a.push(c), t < n.length - 1 && a.push(/* @__PURE__ */ p.cloneElement(s, {
    key: `separator-${t}`
  })), a), []);
}
const H = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], J = ({
  ownerState: e,
  theme: s
}) => {
  let n = {
    display: "flex",
    flexDirection: "column",
    ...k({
      theme: s
    }, u({
      values: e.direction,
      breakpoints: s.breakpoints.values
    }), (a) => ({
      flexDirection: a
    }))
  };
  if (e.spacing) {
    const a = G(s), c = Object.keys(s.breakpoints.values).reduce((o, r) => ((typeof e.spacing == "object" && e.spacing[r] != null || typeof e.direction == "object" && e.direction[r] != null) && (o[r] = !0), o), {}), t = u({
      values: e.direction,
      base: c
    }), m = u({
      values: e.spacing,
      base: c
    });
    typeof t == "object" && Object.keys(t).forEach((o, r, i) => {
      if (!t[o]) {
        const l = r > 0 ? t[i[r - 1]] : "column";
        t[o] = l;
      }
    }), n = N(n, k({
      theme: s
    }, m, (o, r) => e.useFlexGap ? {
      gap: v(a, o)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${H(r ? t[r] : e.direction)}`]: v(a, o)
      }
    }));
  }
  return n = O(s.breakpoints, n), n;
};
function K(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: s = L,
    useThemeProps: n = q,
    componentName: a = "MuiStack"
  } = e, c = () => T({
    root: ["root"]
  }, (o) => F(a, o), {}), t = s(J);
  return /* @__PURE__ */ p.forwardRef(function(o, r) {
    const i = n(o), f = U(i), {
      component: l = "div",
      direction: h = "column",
      spacing: S = 0,
      divider: y,
      children: g,
      className: j,
      useFlexGap: x = !1,
      ...C
    } = f, P = {
      direction: h,
      spacing: S,
      useFlexGap: x
    }, R = c();
    return /* @__PURE__ */ M.jsx(t, {
      as: l,
      ownerState: P,
      ref: r,
      className: B(R.root, j),
      ...C,
      children: y ? z(g, y) : g
    });
  });
}
const w = K({
  createStyledComponent: b("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, s) => s.root
  }),
  useThemeProps: (e) => D({
    props: e,
    name: "MuiStack"
  })
});
export {
  w as S,
  A as s
};
//# sourceMappingURL=Stack-BsxljEnZ.mjs.map
